<template>
	<div class="end-of-results-banner">
		<p class="footer-hline" />
		<Flag16 class="footer-icon" />
		<p class="footer-hline" />
	</div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Flag16 from "@carbon/icons-vue/es/flag/16";
export default defineComponent({ name: "EndOfRepoListMarker", components: { Flag16 } });
</script>

<style lang="scss" scoped>
.end-of-results-banner {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: var(--sgnl-space-16);
	padding: var(--sgnl-space-16);
}
.footer-hline {
	display: block;
	height: 1px;
	margin: 0;
	padding: 0;
	width: 2rem;
	border: 0;
	border-top: 1.5px solid var(--sgnl-default-secondary-border);
}
.footer-icon {
	color: var(--sgnl-default-secondary-icon);
}
</style>
